import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css'
import './styles/formattedResponse.css'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: window.location.origin + '/ingest',
  person_profiles: 'identified_only',
})

const oreogBanner = `

 ██████╗ ██████╗ ███████╗ ██████╗  ██████╗ 
██╔═══██╗██╔══██╗██╔════╝██╔═══██╗██╔════╝ 
██║   ██║██████╔╝█████╗  ██║   ██║██║  ███╗
██║   ██║██╔══██╗██╔══╝  ██║   ██║██║   ██║
╚██████╔╝██║  ██║███████╗╚██████╔╝╚██████╔╝
 ╚═════╝ ╚═╝  ╚═╝╚══════╝ ╚═════╝  ╚═════╝ 
                                            
`;

console.log(oreogBanner);

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </PostHogProvider>
);
